import React, { Component } from 'react';
import logologin from '../../../Comman/images/logo.png'
import { Link } from 'react-router-dom';

class HeartRunnerLeftMenuComponent extends Component {
    constructor(props) {

        super(props);
        this.logout=this.logout.bind(this);

    }
    componentDidMount(){
      
    }
    logout() {
        console.log(this.props)

       this.props.logout();
    }
    render() {
        return (
            <nav className="main-menu">
        <ul>
            <li>
                <Link className="nav-link" to="/HeartRunner/Profile">
                    <i className="fa fa-home nav_icon"> </i>
                    <span > 
                    Profile
                     </span> 
                </Link>
            </li>
            {/*<li className="has-subnav">
                <Link className="nav-link" to="/superadmin/organisations">
                    <i className="fa fa-window-maximize nav_icon" aria-hidden="true"></i>
                    <span>Organisations</span>
                    <i className="icon-angle-right"></i><i className="icon-angle-down"></i>
                </Link>
                <ul className="dropdown">
                    <li>
                        <Link className="nav-link" to="/superadmin/organisations">
                         Organisations List
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/superadmin/approveorganisation">
                        Pending Organisations Requests
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/superadmin/addorganization">
                        Add Organization
                        </Link>
                    </li>
                    
                </ul>
            </li>
            <li className="has-subnav">
                <Link className="nav-link" to="/superadmin/IncomingAlarmFields">
                    <i className="fa fa-cog" aria-hidden="true"></i>
                
                    <span > 
                        Incoming Alarm Fields
                    </span> 
                </Link>
                <ul className="dropdown">
                    <li>
                        <Link className="nav-link" to="/superadmin/IncomingAlarmFields">
                            Incoming Alarm Fields
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/superadmin/Alarmtemplates">
                            Templates
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-link" to="/superadmin/OrganizationAlarmtemplates">
                            Configure Admin 
                        </Link>
                    </li>
                   
                    
                </ul>
            </li>
            <li>
                <Link className="nav-link" to="/superadmin/HeartRunners">
                    
                    <i class="fas fa-running" aria-hidden="true"></i>
                    <span > 
                        First Responder
                    </span> 
                </Link>
                <ul className="dropdown">
                    <li>
                        <Link className="nav-link" to="/superadmin/addHeartRunner">
                            New Heart Runner
                        </Link>
                    </li>
                </ul>    
            </li>
            <li>
                <Link className="nav-link" to="/superadmin/settings">
                    <i className="fa fa-cog" aria-hidden="true"></i>
                   
                    <span > 
                        Settings
                    </span> 
                </Link>
        </li>*/}
            
        
        </ul>
        <ul className="logout">
            <li>
            <a href="#" onClick={this.logout} >
            <i className="icon-off nav-icon"></i>
            <i className="fa fa-sign-out" aria-hidden="true"></i>
            <span >
                Logout
            </span>
            </a>
            </li>
        </ul>
    </nav>
            
        );
    }
}

export default HeartRunnerLeftMenuComponent;